module.exports = __webpack_public_path__ + "img/icon_filter.04c785bd.svg";